import { gql } from '@apollo/client'
import { PICOS_PRIORITY_FRAGMENT } from './PicOSPriorityFragment'

export const GROUPED_PRIORITY_COMPLIANCE_FRAGMENT = gql`
  fragment PicOSGroupedPriorityCompliance on PicOSGroupedPriorityCompliance {
    id
    remainingToTargetExecution
    expectedUnitSales
    numPriorities
    priority {
      ...PicOSPriority
    }
    regionCompliance {
      id
      name
      compliancePercentage
      priorityId
    }
  }
  ${PICOS_PRIORITY_FRAGMENT}
`
